import ReferralsList from './ReferralsList';
export default ReferralsList;